










import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
import {Icon} from "@/helpers/icons";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import BillList from "@/components/bill/BillList.vue";
import {Permissions} from "@/helpers/constants";
import BillCreateDialog from "@/components/bill/BillCreateDialog.vue";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {
		BillCreateDialog,
		BillList,
		AsiContentContainer,
		AsiPageTitle
	}
})
export default class Bills extends Vue {

	private icons = Icon;
	private createDialogOpen = false;

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	private get company(): CompanySimple | null {
		return this.isCustomer ? this.$store.state.user.loggedInUserCompany : null;
	}

}
